<template>
    <div class="order">
        <div class="order-header" @click.prevent="showOrder = !showOrder" :aria-expanded="showOrder" role="button">
            <div class="order-header-icon">
                <svg version="1.1" id="" xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     width="64px" height="64px" viewBox="0 0 64 64" enable-background="new 0 0 64 64">
                    <polygon fill=""
                             points="36.238,44.061 24.271,32.226 36.156,20.115 37.996,21.918 27.907,32.199 38.05,42.229 "/>
                </svg>
            </div>
            <div class="order-header-title">
                №{{ orderData.id }} / {{ orderData.created_at }} / {{ $root.priceFormat(orderData.total_price) }}
                &#8381;
            </div>
            <div class="order-header-status">
                <span
                    :class="{ 'order-status--done': orderData.status.completed, 'order-status--canceled': orderData.status.cancelled, 'order-status--in-process': !orderData.status.completed && !orderData.status.cancelled }">
                    <svg v-if="orderData.status.completed" aria-hidden="true" role="img"
                         xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path fill=""
                              d="M435.848 83.466L172.804 346.51l-96.652-96.652c-4.686-4.686-12.284-4.686-16.971 0l-28.284 28.284c-4.686 4.686-4.686 12.284 0 16.971l133.421 133.421c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-28.284-28.284c-4.686-4.686-12.284-4.686-16.97 0z"></path>
                    </svg>
                    <svg v-if="orderData.status.cancelled" aria-hidden="true" focusable="false" role="img"
                         xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                        <path fill=""
                              d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"></path>
                    </svg>
                    <svg v-if="!orderData.status.completed && !orderData.status.cancelled" aria-hidden="true"
                         focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path fill=""
                              d="M288 32c0 17.673-14.327 32-32 32s-32-14.327-32-32 14.327-32 32-32 32 14.327 32 32zm-32 416c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm256-192c0-17.673-14.327-32-32-32s-32 14.327-32 32 14.327 32 32 32 32-14.327 32-32zm-448 0c0-17.673-14.327-32-32-32S0 238.327 0 256s14.327 32 32 32 32-14.327 32-32zm33.608 126.392c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm316.784 0c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zM97.608 65.608c-17.673 0-32 14.327-32 32 0 17.673 14.327 32 32 32s32-14.327 32-32c0-17.673-14.327-32-32-32z"></path>
                    </svg>
                    {{ orderData.status.name }}
                </span>
            </div>
            <div class="order-header-img">
                <img alt="" v-for="item in orderData.items" :src="item.images[0]['preview']" />
            </div>
        </div>
        <transition name="collapse">
            <div v-if="showOrder" class="order-body">
                <div class="order-details">
                    <h5 v-if="orderData.delivery_date">Дата доставки {{ orderData.delivery_date }}</h5>
                    <div class="row">
                        <div v-if="isAvailableToCancel()" class="col-12 mb-4">
                            <q-btn color="primary" label="Отменить заказ" @click.prevent="cancel"></q-btn>
                        </div>
                        <div class="col-12 col-sm-6">
                            <div class="order-details-item">
                                <span>Получатель</span>
                                <span></span>
                                <span>
                                <span>{{ orderData.first_name }} {{ orderData.middle_name }} {{
                                        orderData.last_name
                                    }}</span>
                                <span>{{ orderData.phone_number }}</span>
                                <span v-if="orderData.email">{{ orderData.email }}</span>
                            </span>
                            </div>
                            <div class="order-details-item">
                                <span>Способ доставки</span>
                                <span></span>
                                <span>{{ orderData.delivery_method }}</span>
                            </div>

                            <div v-if="orderData.pickup_point" class="order-details-item">
                                <span>Пункт выдачи зачаза:</span>
                                <span></span>
                                <span>{{ orderData.pickup_point.name }} ({{
                                        orderData.shipping_address
                                    }}, {{ orderData.pickup_point.address }})</span>
                            </div>
                            <div v-if="orderData.pickup_point" class="order-details-item">
                                <span>Время работы пункта самовывоза</span>
                                <span></span>
                                <span>{{ orderData.pickup_point.work_time }}</span>
                            </div>
                            <div v-if="!orderData.pickup_point" class="order-details-item">
                                <span>Адрес доставки</span>
                                <span></span>
                                <span>{{ orderData.shipping_address }}</span>
                            </div>
                            <div class="order-details-item">
                                <span>Способ оплаты</span>
                                <span></span>
                                <span>{{ orderData.payment_type }}</span>
                            </div>
                            <div v-if="isWaitingToPay" class="order-details-item">
                                <template>
                                    <q-btn
                                        type="submit"
                                        class="bg-primary text-white q-mt-md"
                                        label="Оплатить" @click.prevent="goToPaymentPage"/>
                                </template>
                            </div>
                        </div>
                        <div class="col-12 col-sm-5 offset-sm-1">
                            <div class="order-details-item">
                                <span>Товаров в заказе:</span>
                                <span></span>
                                <span>{{ orderData.items.length }}</span>
                            </div>
                            <div v-for="total in orderData.totals" class="order-details-item">
                                <span>{{ total.name }}:</span>
                                <span></span>
                                <span>{{ $root.priceFormat(total.amount) }} &#8381;</span>
                            </div>
                            <div class="order-details-item order-details-item--total">
                                <span>ИТОГО К ОПЛАТЕ:</span>
                                <span></span>
                                <span>{{ $root.priceFormat(orderData.total_price) }} &#8381;</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="order-items">
                    <div v-for="item in orderData.items" class="order-item">
                        <a :href="item.url" class="order-item-img">
                            <img :src="item.images[0]['preview']">
                        </a>
                        <div class="order-item-text">
                            <div class="order-item-title">{{ item.primary_category }} {{ item.brand }}</div>
                            <div class="order-item-options">
                                <div class="order-item-option">Артикул: <span> {{ item.article }}</span></div>
                                <div v-if="item.size" class="order-item-option">Размер: <span>{{ item.size }}</span>
                                </div>
                                <div class="d-block d-sm-none order-item-option">Цена:
                                    <span>{{ $root.priceFormat(item.final_price) }} &#8381;</span></div>
                            </div>
                        </div>
                        <div class="d-none d-sm-block order-item-price">{{ $root.priceFormat(item.final_price) }}
                            &#8381;
                        </div>
                        <div class="order-actions">
                            <q-btn outline
                                   v-if="isAvailableReview({userReview:item.user_review, productStatus:item.product_status})"
                                   label="Оставить отзыв"
                                   @click.prevent="review(item.product_id)"
                                   class=""
                            />
                            <div v-if="isExistUserReview(item.user_review)" class="product-rating flex-column">
                                Ваша оценка
                                <div class="product-rating-stars m-0">
                                    <span v-for="i in 5" class="star icon"
                                          :class="{'fill': i <= Math.round(item.user_review[0].rating)}"></span>
                                </div>
                            </div>

                            <q-checkbox
                                :value="toReturn(orderData.id, item.id)"
                                @input="toggleReturnProduct({ orderId: orderData.id, itemId: item.id })"
                                label="Вернуть"
                                class="mt-3 mb-3 ml-md-3 mr-md-4"
                            />

                            <div class="order-refund">
                                <div v-if="toReturn(orderData.id, item.id)" class="order-refund-reason">
                                    <q-select
                                        square
                                        outlined
                                        :behavior="$q.platform.is.ios || $q.platform.is.android === true ? 'menu' : 'default'"
                                        dense
                                        input-debounce="0"
                                        name="reason"
                                        label="Выберите причину возврата"
                                        v-model="form.productToReturn[item.id]"
                                        @input="setReason({ event: $event, orderId: orderData.id, itemId: item.id })"
                                        :options="returnReasons"
                                        :options-dense="true"
                                        emit-value
                                        map-options
                                    />
                                </div>

                                <div v-if="otherReason(orderData.id, item.id)" class="order-refund-reason-other mt-2">
                                    <q-input dense square outlined type="textarea" autogrow
                                             label="Ваша причина возврата"
                                             @input="setOtherReasonValue({ event: $event, orderId: orderData.id, itemId: item.id })"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="returnProducts.length" class="order-refund-wrap">
                    <q-btn color="primary" label="Оформить возврат" @click.prevent="returnOrder = orderData.id"
                           class="ml-lg-auto"></q-btn>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import {mapState, mapGetters, mapActions} from 'vuex';

export default {
    name: 'CustomerOrder',
    props: {
        order: {
            required: true,
            type: Object
        },
    },
    data() {
        return {
            orderData: {},
            creditPaymentType: 3,
            awaitingStatusId: [3],
            availableToCancel: [1, 3],
            reason: {
                reasonKey: '',
                reason: ''
            },
            test: 'size',
            form: {
                productToReturn: []
            },
            confirmCancel: false,
            showOrder: false,
        }
    },
    created() {
        this.orderData = this.order;
    },
    methods: {
        ...mapActions('customer', [
            'toggleReturnProduct',
            'setReason',
            'setOtherReasonValue',
        ]),
        review(productId) {
            this.$emit('review', productId);
        },
        isWaitingToPay() {
            return this.awaitingStatusId.indexOf(this.orderData.status.id) !== -1;
        },
        isAvailableToCancel() {
            return this.availableToCancel.indexOf(this.orderData.status.id) !== -1;
        },
        cancel() {
            let _this = this;

            this.$q.dialog({
                title: 'Подтвердите действие',
                message: 'Вы действительно хотите отменить заказ?',
                // cancel: true,
                persistent: true,
                ok: 'Да',
                cancel: 'Нет'
            }).onOk(() => {
                axios.post(`/account/orders/${_this.orderData.id}/cancel`)
                    .then(response => {
                        if (response.data.status === 'success') {
                            if (response.data.order) {
                                _this.orderData = response.data.order;
                            }
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            });
        },
        goToPaymentPage() {
            window.location.href = this.orderData.payment_link;
        },
        isExistUserReview(userReview) {
            return userReview.length !== 0;
        },
        isProductAvailable(productStatus) {
            return productStatus;
        },
        isOrderCompleted() {
            return this.orderData.status.completed;
        },
        isAvailableReview({userReview, productStatus}) {
            return !this.isExistUserReview(userReview) && this.isProductAvailable(productStatus) && this.isOrderCompleted();
        }
    },
    computed: {
        ...mapState('customer', [
            'returnReasons',
            'returnProducts',
        ]),
        ...mapGetters('customer', [
            'toReturn',
            'otherReason',
        ]),
        returnOrder: {
            get() {
                return !!this.$store.state.customer.returnOrder;
            },
            set(value) {
                this.$store.commit('customer/returnOrder', value);
            }
        },
    }
}
</script>
